import { AHThemeType, CircleSize, useCircleSize, useTheme } from "arkh";

import { EmptyResult } from "./EmptyResult";
import { Feather } from "@expo/vector-icons";
import React from "react";

import { View } from "react-native";

type Sentiment = "POSITIVE" | "NEGATIVE" | "NEUTRAL";
export const getIconName = (sentiment: Sentiment) => {
  switch (sentiment) {
    case "POSITIVE":
      return "check";
    case "NEGATIVE":
      return "x";
    case "NEUTRAL":
    default:
      return "check";
  }
};
export const getColor = (sentiment: Sentiment, theme: AHThemeType) => {
  switch (sentiment) {
    case "POSITIVE":
      return theme.positive;
    case "NEGATIVE":
      return theme.negative;
    case "NEUTRAL":
    default:
      return "black";
  }
};

export const TaskExecutionCheckSentimentNoAnswerIcon = (props: {
  size: CircleSize;
}) => {
  const scaledSize = useCircleSize(props.size);
  return (
    <View
      style={{
        width: scaledSize,
        height: scaledSize,
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <EmptyResult absoluteSize={scaledSize} />
    </View>
  );
};

const TaskOptionsOptionC = (props: {
  sentiment: Sentiment | null;
  size: CircleSize;
}) => {
  const theme = useTheme();
  const scaledSize = useCircleSize(props.size);
  const sentiment = props.sentiment;
  return (
    <>
      {sentiment ? (
        <View
          style={{
            borderRadius: Math.ceil(scaledSize / 2),
            width: scaledSize,
            height: scaledSize,
            borderColor: getColor(sentiment, theme),
            backgroundColor: getColor(sentiment, theme),
            borderWidth: 2,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Feather
            name={getIconName(sentiment)}
            color={theme.lightText}
            size={scaledSize / 2}
          />
        </View>
      ) : (
        <TaskExecutionCheckSentimentNoAnswerIcon size={props.size} />
      )}
    </>
  );
};

export const TaskExecutionCheckSentimentIcon = React.memo(TaskOptionsOptionC);
